import React, { Component } from 'react'
import { Icon } from './UI'

class Rating extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: Math.round(props.value)
    }
  }
  render() {
    const { props, state } = this
    const initial = Math.round(props.value)

    return (
      <div
        style={props.style}
        className={`gp-rating ${props.className} ${props.big ? 'big' : ''} ${
          props.bigger ? 'bigger' : ''
        } ${props.interactive ? 'interactive' : ''} ${
          props.text ? 'with-text' : ''
        }`}
      >
        {new Array(props.size).fill(0).map((v, i) => (
          <span
            className='gp-icon-container'
            onClick={() => {
              if (props.interactive && state.value !== i + 1) {
                this.setState({ value: i + 1 })
                this.props.onChange(i + 1)
              }
            }}
            key={`star-${i}`}
          >
            <Icon
              name={
                i < (props.interactive ? state.value : initial)
                  ? 'star'
                  : 'star outline'
              }
              className={`${
                i < (props.interactive ? state.value : initial) ? 'active' : ''
              }`}
            />
          </span>
        ))}
        {props.text && <span>{state.value}</span>}
      </div>
    )
  }
}

Rating.defaultProps = {
  className: '',
  style: {},
  size: 5
}

export default Rating
